<template>
  <div class="com-table balance border infoListWrap">
    <div class="com-title pr">招商智投（智投）</div>
    <div class="ms-list">
      <div ref="msSearch" class="resource-search">
        <el-button type="primary" @click="exportFile()" class="dia-btn exportFile">导出</el-button>
        <ms-search :data="search.list" @click="updateConditions"/>
      </div>

      <el-dialog title="修改" :visible.sync="dialogVisible" width="30%" top="15%" center>
        <el-input type="textarea" :rows="10" v-model="message.remark" placeholder="请输入内容"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="modifierRemrak()">提 交</el-button>
        </span>
      </el-dialog>

      <!-- <div class="resource-count">
        <span><img class="icon" src="../../assets/images/count_icon.png"/>资源需求量<span>{{num1}}条</span>,资源获得量<span>{{num2}}条</span></p>
      </div> -->
      <template v-if="table.list.length!==0">
        <el-button size="small" type="danger" @click="deleteList()">批量删除</el-button>
        <el-button size="small" type="primary" @click="showAllFp()">批量手动分配</el-button>
        <el-button size="small" type="primary" @click="changeRead(0)">批量已读</el-button>
        <el-button size="small" type="primary" @click="changeRead(1)">批量未读</el-button>
      </template>
      <el-table
        v-loading="table.loading"
        size="small"
        :data="this.table.list"
        :fit="true"
        @selection-change="handleSelectionChange">
        <template slot="empty">
          <no-data></no-data>
        </template>
        <el-table-column
          type="selection"
          width="45"
          center>
        </el-table-column>
        <el-table-column label="" min-width="40" fixed="left">
          <template slot-scope="scope">
            <span>
              <i class="el-icon-delete" @click="deletes(scope.$index)"></i>
            </span>
            <span class="isRead">
              <template v-if="scope.row.readStatus === 0">
                <i class="el-icon-s-comment" title="标为已读" @click="read(scope.$index)"></i>
                <i class="unRead-icon"></i>
              </template>
              <template v-else>
                <i class="el-icon-s-comment" title="标为未读" @click="unRead(scope.$index)"></i>
              </template>
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="itemTitle"  label="项目名称" min-width="80">
          <template slot-scope="scope">
            <!-- <template v-if="scope.row.readStatus === 0">
              <i class="unRead-icon"></i>
            </template> -->
            {{scope.row.itemTitle}}
          </template>
        </el-table-column>
        <el-table-column prop="contact" label="姓名" min-width="70"></el-table-column>
        <el-table-column prop="mobile" label="手机号码" width="110"></el-table-column>
        <el-table-column prop="mobileStatus" label="号码类型" min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.mobileStatus === 1">正常号</span>
            <span v-else>疑似问题号</span>
          </template>
        </el-table-column>
        <el-table-column prop="other" label="其他联系" min-width="80"></el-table-column>
        <el-table-column prop="channelTitle" label="推广渠道" min-width="100" v-if="showChannelTitle"></el-table-column>
        <el-table-column prop="searchWord" label="关键词" min-width="70"></el-table-column>
        <el-table-column prop="region" label="地域" min-width="60"></el-table-column>
        <!--<el-table-column prop="data" label="详细信息" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.pageUrl !== undefined">着陆页：{{scope.row.pageUrl}}</span>
          </template>
        </el-table-column>-->
        <!-- <el-table-column align="center" prop="channelTitle" label="推广平台" v-if="showChannel" min-width="100"></el-table-column> -->
        <!-- <el-table-column align="center" prop="channelTitle" label="平台名称" min-width="90"></el-table-column> -->
        <el-table-column align="center" prop="resType" label="来源类型" min-width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.resType === 1">表单</span>
            <span v-if="scope.row.resType === 2">智能聊天</span>
          </template>
        </el-table-column>
        <el-table-column prop="otherInfo" label="其他信息" min-width="90"></el-table-column>
        <el-table-column prop="publishTime" label="创建时间" min-width="90"></el-table-column>
        <el-table-column prop="crmFollower" label="接收人" min-width="70"></el-table-column>
        <el-table-column prop="descrip" label="画像" min-width="70"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="90">
          <template slot-scope="scope">
            <span>{{scope.row.remark}}</span>
            <span @click="popUs(scope.$index)" style="cursor: pointer">
              <icon name="pencil-square-o"></icon>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="跟进详情" min-width="100" v-if="callData">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="left" width="500">
              <template v-if="scope.row.callData !== null">
                <p v-for="item in scope.row.callData" :key="item.id">{{ item.callTime }}：{{item.message}}</p>
                <div slot="reference" class="callDataList">
                  <span v-for="(item,index) in scope.row.callData" :key="item.id" v-if="index===0">
                    {{ item.callTime }}：{{item.message}}
                  </span>
                </div>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="70">
          <template slot-scope="scope">
            <template v-if="scope.row.crmFollower.length === 0 && !scope.row.crmPushed">
              <el-button type="text" size="small" @click="showFp(scope.$index)">手动分配</el-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="落地页" min-width="100" v-if="showPageUrl">
          <template slot-scope="scope">
            <a class="pageUrl" :href="scope.row.pageUrl" target="_blank">{{scope.row.pageUrl}}</a>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="操作" min-width="80">
          <template slot-scope="scope">
            <span class="changeStatus unRead" v-if="scope.row.readStatus === 0" size="small" type="primary" @click="read(scope.$index)">标为已读</span>
            <span class="changeStatus" v-else size="small" type="success" @click="unRead(scope.$index)">标为未读</span>
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="table.pagination.page"
        :total="table.pagination.totalRow"
        :page-size="table.pagination.pageSize"
        :page-sizes="table.pagination.pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog center align = "center" :visible.sync="dialogFpVisible" width="40%" :close-on-click-modal="false">
      <p style="text-align:center;">接收人：
        <el-select
          v-model="distribute.id"
          filterable
          remote
          placeholder="请输入话务人员姓名"
          :remote-method="remoteMethod"
          :loading="loading"
          style="width:50%">
          <template v-if="channelSource === 2">
            <el-option v-for="item in userList" :key="item.id" :label="item.sourceName" :value="item.sourceId"></el-option>
          </template>
          <template v-else>
            <el-option v-for="item in userList" :key="item.id" :label="item.userName" :value="item.id"></el-option>
          </template>
        </el-select>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="loading" @click="saveDistribute">确 定</el-button>
        <el-button @click="dialogFpVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import MsSearch from '@/components/common/Search.vue'
  import moment from 'moment'
  import MsConfirmButton from '@/components/common/ConfirmButton.vue'
  import MsSlide from '@/components/common/Slide.vue'
  import Items from '@/api/items'
  import Api from '@/api/client/resource'
  import ResponseParse from '@/utils/response-parse'
  import {SEARCH_CONDITION} from '@/models/client/resource'

  export default {
    components: {
      MsSlide,
      MsSearch,
      MsConfirmButton
    },
    data () {
      return {
        userInfo: {},
        showPageUrl: false,
        callData: false,
        dialogVisible: false,
        dialogFpVisible: false,
        showChannelTitle: false,
        loading: false,
        userList: [],
        IdList: [],
        IdList1: [], // modeType为3(cpc/ocpc类型)
        resourceList: [],
        distribute: {},
        search: {
          list: [],
          condition: {}
        },
        table: {
          loading: true,
          list: [],
          pagination: {}
        },
        message: {
          remark: ''
        },
        num1: 0,
        num2: 0,
        channelSource: 1 // 2:按客人来源 1:按员工来源(默认)
      }
    },
    created () {
      this.userInfo = JSON.parse(sessionStorage.getItem('user'))
      this.search.list = SEARCH_CONDITION
      let date = []
      date[0] = moment().subtract(0, 'days').format('YYYY-MM-DD')
      date[1] = moment().subtract(0, 'days').format('YYYY-MM-DD')
      this.search.condition.startTime = date[0]
      this.search.condition.endTime = date[1]
      this.search.list[0].value = date
      Items.getItems(response => {
        let itemTitle = response.data.data
        let title = []
        itemTitle.forEach(value => {
          if (value.modeType !== 1) {
            title.push({value: value.id, label: value.title})
          }
        })
        this.search.list[1].config.list = title
      })

      this.table.list = []
      this.requestList()
      this.getSummary()
      this.getChannerSource()
    },
    methods: {
      async getChannerSource () {
        let response = await Api.getCrmAssignResourceType()
        let status = response.status || 0
        let body = response.data || {}
        if (status >= 200 || status <= 204) {
          this.channelSource = body.assignResourceType
        }
      },
      handleSelectionChange (val) {
        let IdList = []
        let IdList1 = [] // modeType为3(cpc/ocpc类型)
        this.resourceList = [] // 批量手动分配需要的参数
        val.forEach((val, index) => {
          const form = {}
          form.id = val.id
          form.taleName = val.tableName
          this.resourceList.push(form)
          this.table.list.forEach((v, i) => {
            if (val.id === v.id) {
              if (val.modeType === 3) {
                IdList1.push(v.id)
              } else {
                IdList.push(v.id)
              }
            }
          })
        })
        this.IdList = IdList
        this.IdList1 = IdList1
      },
      getSummary () {
        let params = Object.assign({}, this.search.condition)
        Api.getSummary({search: params}, response => {
          let status = response.status || 0
          let body = response.data || {}
          if (status >= 200 || status <= 204) {
            this.num2 = body.itemId
            this.num1 = body.itemSolutionId
          }
        })
      },
      requestList () {
        this.table.loading = true
        let params = Object.assign({}, this.table.pagination, this.search.condition)
        Api.list({search: params}, response => {
          let status = response.status || 0
          let body = response.data || []
          if ((status >= 200 || status <= 204) && body.length > 0) {
            this.table.list = body
            this.table.pagination = ResponseParse.pagination(response.headers)
            if (this.table.list[0].showChannelTitle) {
              this.showChannelTitle = true
            } else {
              this.showChannelTitle = false
            }
            if (this.table.list[0].callData) {
              this.callData = true
            } else {
              this.callData = false
            }
            if (this.table.list[0].showPageUrl) {
              this.showPageUrl = true
            } else {
              this.showPageUrl = false
            }
          } else {
            this.showChannelTitle = false
            this.showPageUrl = false
            this.table.list = []
          }
          this.table.loading = false
        })
      },
      deleteList () {
        if (this.IdList.length === 0 && this.IdList1.length === 0) {
          this.$message.error('请先选择要删除的数据')
          return false
        }
        this.$confirm('确定删除?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          if (this.IdList.length !== 0) {
            Api.deleteList({ids: this.IdList}, () => {
              this.requestList()
            })
          }
          if (this.IdList1.length !== 0) {
            Api.deleteList1({ids: this.IdList1}, () => {
              this.requestList()
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      changeRead (type) {
        // type:0 批量已读 type:1 批量未读
        if (this.IdList.length === 0 && this.IdList1.length === 0) {
          this.$message.error('请先选择要删除的数据')
          return false
        }
        if (type === 0) {
          if (this.IdList.length !== 0) {
            Api.allReadList({ids: this.IdList}, response => {
              let status = response.status || 0
              let body = response.data || {}
              if (status >= 200 && status <= 204) {
                const data = body.list
                this.changeList(data)
              } else {
                this.$message.error(body.error || '操作失败')
              }
            })
          }
          if (this.IdList1.length !== 0) {
            Api.allReadList1({ids: this.IdList1}, response => {
              let status = response.status || 0
              let body = response.data || {}
              if (status >= 200 && status <= 204) {
                const data = body.list
                this.changeList(data)
              } else {
                this.$message.error(body.error || '操作失败')
              }
            })
          }
        } else {
          if (this.IdList.length !== 0) {
            Api.allUnreadList({ids: this.IdList}, response => {
              let status = response.status || 0
              let body = response.data || {}
              if (status >= 200 && status <= 204) {
                const data = body.list
                this.changeList(data)
              } else {
                this.$message.error(body.error || '操作失败')
              }
            })
          }
          if (this.IdList1.length !== 0) {
            Api.allUnreadList1({ids: this.IdList1}, response => {
              let status = response.status || 0
              let body = response.data || {}
              if (status >= 200 && status <= 204) {
                const data = body.list
                this.changeList(data)
              } else {
                this.$message.error(body.error || '操作失败')
              }
            })
          }
        }
      },
      changeList (data) {
        this.table.list.forEach(item => {
          data.forEach(item1 => {
            if (item.id === item1.id) {
              item.readStatus = item1.readStatus
            }
          })
        })
      },
      deletes (index) {
        this.$confirm('确定删除?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          Api.delete({id: this.table.list[index].id}, response => {
            let status = response.status
            if (status >= 200 && status <= 204) {
              this.requestList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      remoteMethod (query) {
        let search = {}
        search.userName = query
        let ApiName = 'likeness'
        if (this.channelSource === 2) {
          ApiName = 'speLikeness'
          search.userName = ''
          search.sourceName = query
        }
        Api[ApiName]({search: search}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status >= 200 && status <= 204) {
            this.userList = body
          }
        })
      },
      thridPush () {
        this.$confirm('确定操作？', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '分配中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          Api.assignResourcesManuallyByThridPush({form: this.distribute}, response => {
            loading.close()
            let status = response.status || 0
            let body = response.data || []
            if (status >= 200 && status <= 204) {
              this.$message.success(body.submitResult ? '操作成功：' + body.submitResult : '分配成功')
              this.requestList()
            } else {
              this.$message.error(body.error ? '操作失败：' + body.error : '分配失败')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      },
      showFp (index) {
        const item = this.table.list[index]
        const form = {}
        form.id = item.id
        form.taleName = item.tableName
        this.distribute.resourceList = [form]
        if (this.channelSource === 3) {
          this.thridPush()
        } else {
          this.dialogFpVisible = true
        }
      },
      showAllFp () {
        if (this.IdList.length === 0) {
          this.$message.error('请先选择要手动分配的数据')
          return false
        }
        this.distribute.resourceList = this.resourceList
        if (this.channelSource === 3) {
          this.thridPush()
        } else {
          this.dialogFpVisible = true
        }
      },
      saveDistribute () {
        this.loading = true
        let ApiName = 'distribute'
        if (this.channelSource === 2) {
          ApiName = 'speDistribute'
          this.distribute.channelSourceCode = this.distribute.id
        } else {
          this.distribute.userId = this.distribute.id
        }
        Api[ApiName]({form: this.distribute}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status >= 200 && status <= 204) {
            this.dialogFpVisible = false
            this.$message.success(body.submitResult ? '操作成功：' + body.submitResult : '分配成功')
            this.requestList()
            // this.userList = body
          } else {
            this.$message.error(body.error ? '操作失败：' + body.error : '分配失败')
          }
          this.loading = false
        })
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        const time = conditions.time || []
        this.search.condition = Object.assign({}, conditions, {startTime: time[0], endTime: time[1]})
        this.requestList()
      },
      popUs (index) {
        this.dialogVisible = true
        this.message.index = index
        this.message.remark = this.table.list[index].remark
        this.message.id = this.table.list[index].id
      },
      modifierRemrak () {
        Api.modify({id: this.message.id, remark: this.message.remark}, response => {
          let status = response.status || 0
          if (status >= 200 && status <= 204) {
            let data = this.table.list[this.message.index]
            data.remark = this.message.remark
            this.table.list.splice(this.message.index, 1, data)
            this.dialogVisible = false
            this.$message.success('修改成功')
          } else {
            this.$message.error('修改失败')
          }
        })
      },
      read (index) {
        Api.read({id: this.table.list[index].id}, response => {
          let status = response.status
          if (status >= 200 && status <= 204) {
            let data = this.table.list[index]
            data.readStatus = 1
            // 将原值替换为修改后的值
            this.table.list.splice(index, 1, data)
          }
        })
      },
      unRead (index) {
        Api.unread({id: this.table.list[index].id}, response => {
          let status = response.status
          if (status >= 200 && status <= 204) {
            let data = this.table.list[index]
            data.readStatus = 0
            // 将原值替换为修改后的值
            this.table.list.splice(index, 1, data)
          }
        })
      },
      exportFile () {
        let search = ''
        this.search.list.forEach(item => {
          let text = item.name
          let value = item.value
          if (item.type === 'select') {
            if (item.hasOwnProperty('config') && item.config.hasOwnProperty('list')) {
              item.config.list.forEach(function (option) {
                if (option.label === item.value) {
                  value = option.value
                }
              })
            }
          }
          if (search === '') {
            if (text === 'time' && value !== '') {
              search = '?startTime=' + value[0] + '&endTime=' + value[1]
            } else {
              if (value !== '') {
                search = '?' + text + '=' + value
              }
            }
          } else {
            if (text === 'time' && value !== '') {
              search = '&startTime=' + value[0] + '&endTime=' + value[1]
            } else {
              if (value !== '') {
                search += '&' + text + '=' + value
              }
            }
          }
        })
        window.location.href = '/rest/customer/feedback/resource/files' + search
      },
      showSlide (ref) {
        this.$refs[ref].show()
      }
    }
  }
</script>
<style lang="scss">
  .callDataList{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;/*想省略几行就写几*/
    -webkit-box-orient: vertical;
  }
  .infoListWrap.com-table{
    .el-table th,.el-table td{
      text-align: center;
    }
  }
  .pageUrl{
    display: -webkit-box;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .isRead{
    position: relative;
    top:5px;
    .unRead-icon{
      position: absolute;
      top:-5px;
      right:0;
    }
  }
  .el-icon-delete, .el-icon-s-comment{
    font-size: 18px;
    cursor: pointer;
  }
  .unRead-icon{
    width:8px;
    height: 8px;
    display: inline-block;
    background: #f00;
    border-radius: 50%;
  }
  .changeStatus{
    cursor: pointer;
    &.unRead{
      color:#409EFF;
    }
  }
  .resource-list th.is-center,.resource-list td.is-center{
    text-align: center!important;
  }
  .resource-list .el-button--primary{
    background: #2672FF;
    font-size: 14px;
    padding: 8px 10px;
    color:#F8F8F8;
  }
  .resource-list .el-button--success{
    background: #ff2635;
    border-color: #ff2635;
    font-size: 14px;
    color:#F8F8F8;
    padding: 8px 10px;
  }
  .resource-search {
    position: relative;
    .exportFile{
      position: absolute;
      right:10px;
      top: 18px;
      z-index: 2;
      padding: 6px 20px;
    }
  }
  .resource-count{
    background: #eef6ff;
    font-weight: 400;
    margin:20px 0 2px;
    color:#666666;
    font-size: 14px;
    border-radius: 2px;
    padding:0 12px;
    border:1px solid rgba(64, 158, 255, 0.2);
    line-height: 30px;
    .icon{
      position: relative;
      top:5px;
      margin-right:10px;
    }
    p{
      margin:0;
    }
    span{
      color:#409eff;
      margin:0 5px;
    }
  }
  .ms-list {
    position: relative;
    .operation {
      position: absolute;
      top: 13px;
      right: 0px;
      z-index: 99;
    }
    .el-table--small td{
      padding: 9px 0;
    }
    .el-table--small thead th{
      padding: 15px 0;
    }
  }
  .el-table .cell, .el-table th div{
    font-size: 14px;
    color:#666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/Resource.vue